
import { useStore } from "../../state/state.ts";
import Measure from "../measure.tsx";
import ModalFassade from "../../modals/modal_fassade.tsx";
import ModalFassadeFuture from "../../modals/modal_fassade_future.tsx";
import { MASSNAHMEN_FASSADE_OPTIONS_CURRENT_LABELS, MASSNAHMEN_FASSADE_OPTIONS_NEW_LABELS } from "../../state/types.ts";
import { useRef } from "react";

export default function MeasureWidgetFassade() {
  // @ts-ignore:TS6133
  //const _properties = useStore((state)=>state.properties); //MUST EXIST FOR REACTIVITY TO WORK
  const fassade = useStore((state)=>state.fassade || "");
  const fassade_future = useStore((state)=>state.fassade_future || "");
  const ref = useRef<HTMLButtonElement>(null);

  const push_modal = useStore((state) => state.push_modal_closeable);
  const is_step_id = useStore((state) => state.is_step_id);
  const measure_lables = useStore((state)=>state.measure_lables);


    const current = measure_lables[fassade] || MASSNAHMEN_FASSADE_OPTIONS_CURRENT_LABELS[fassade] || "" ;
    const future = measure_lables[fassade_future] || MASSNAHMEN_FASSADE_OPTIONS_NEW_LABELS[fassade_future] || "" ;

  return <Measure 
  id="fassade"
  measure_ref={ref}
  key={"measure-widget-fassade"} 
  label={"Fassade"} 
  now={current} 
  future={future} 
  onClick={() => push_modal(is_step_id("future")?<ModalFassadeFuture/>:<ModalFassade/>, ref)} />;
}
